// src/components/SectionTitle.js
// Shared section heading in the existing brand style
// (centered title, short primary-colored underline, optional subtitle).
import React from 'react';

const SectionTitle = ({ title, subtitle, light = false }) => (
    <div className="my-4 py-4">
        <h2 className={`my-2 text-center text-3xl uppercase font-bold ${light ? 'text-white' : 'text-primary'}`}>
            {title}
        </h2>
        <div className='flex justify-center'>
            <div className={`w-24 border-b-4 ${light ? 'border-accent' : 'border-primary'}`}></div>
        </div>
        {subtitle && (
            <p className={`mt-4 mx-auto max-w-3xl text-center text-lg lg:text-xl font-semibold ${light ? 'text-gray-300' : 'text-gray-600'}`}>
                {subtitle}
            </p>
        )}
    </div>
);

export default SectionTitle;
